// Marketplace token listing shared by the Marketplace page and token staking.

export const MARKETPLACE_API_URL = 'https://airdrop2.domichain.io/v1/exchange';

export interface TokenConfig {
  _id?: string;
  symbol: string;
  name: string;
  publicKey: string;
  exchangeRate: number;
  decimals: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  isNative?: boolean;
}

export async function fetchSupportedTokens(): Promise<TokenConfig[]> {
  const response = await fetch(`${MARKETPLACE_API_URL}/getTokens`);
  if (!response.ok) {
    throw new Error('Failed to fetch supported tokens');
  }
  const responseData = await response.json();
  if (responseData.status !== 'success' || !responseData.data.success) {
    throw new Error(responseData.data?.error || 'Failed to fetch tokens');
  }
  return responseData.data.tokens || [];
}
